// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.editor-container[data-v-52cced3e] {\n  margin-bottom: 30px;\n}\n.tag-title[data-v-52cced3e] {\n  margin-bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
